export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_q03_a.819e716c.png";